import { h } from "preact";
import "../style.css";
import Gift from "./Gift";
import Reward from "./Reward";

const ThankPageWidgets = props => {
  const urlParams = new URLSearchParams(window.location.search);
  const amount = urlParams.get("amount");

  return (
    // removing clean slate for the time being if required paste it below
    <div className="corner-midas-widget">
      {/* only reward pages will have the amount query parameter */}
      {amount ? <Reward /> : <Gift />}
    </div>
  );
};

export default ThankPageWidgets;
